/* eslint-disable import/prefer-default-export */
export const determineIsOnSale = (collection, priceZone) => {
  const listMax = collection?.[`zone_${priceZone}_list_price_max`]
  const listMin = collection?.[`zone_${priceZone}_list_price_min`]
  const saleMax = collection?.[`zone_${priceZone}_sale_price_max`]
  const saleMin = collection?.[`zone_${priceZone}_sale_price_min`]

  if (!listMax || !listMin || !saleMax || !saleMin) {
    return false
  }

  return saleMin < listMin || saleMax < listMax
}

export const determineSwatchData = variations =>
  Object.entries(variations)
    ?.map(([swatchLabel, value]) => {
      const swatchImage = value?.swatch_image

      if (!swatchImage || !swatchLabel) return null

      return {
        image: swatchImage,
        label: swatchLabel,
        // length: (value?.itemImages?.length || 0) + (value?.roomImages?.length || 0),
        length: value?.roomImages?.length || 0,
      }
    })
    .filter(Boolean)
    .reduce((acc, curr, index) => {
      // Calculate the starting index based on previous items' lengths
      const startIndex = index === 0 ? 0 : acc[index - 1].startIndex + acc[index - 1].length

      return [
        ...acc,
        {
          ...curr,
          startIndex,
        },
      ]
    }, [])
    .filter(Boolean)
